// ----------------------------------------------------------------------------
// Snippet: Newsletter Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/icon/icon';

// Styles
import './_newsletter-form.scss';

const NEWSLETTER_FORM = '.form--newsletter';

const newsletterForms = document.querySelectorAll(NEWSLETTER_FORM);

// Attach event listener to each newsletter form
newsletterForms?.forEach(form => {
    form?.addEventListener("submit", function (evt) {
        evt.preventDefault(); // Prevent the default form submission

        // Your code to add a customer tag
        let customerTagsInput = form.querySelector('#customer_tags');
        let currentTags = customerTagsInput.value.split(', ').filter(tag => tag !== "");

        // Get all checkboxes
        const truck_off_road = form.querySelector(".js--truck-off-road");
        const bike = form.querySelector(".js--bike");

        // Function to update tags based on checkbox state
        function updateTag(checkbox) {
            const value = checkbox.value;
            const index = currentTags.indexOf(value);

            if (checkbox.checked) {
                // Add value if not already present
                if (index === -1) {
                    currentTags.push(value);
                }
            } else {
                // Remove value if present
                if (index !== -1) {
                    currentTags.splice(index, 1);
                }
            }
        }

        // Update tags based on checkbox states
        updateTag(truck_off_road);
        updateTag(bike);

        // Update the value of customer_tags input field
        customerTagsInput.value = currentTags.join(', ');
    });
});
